import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { Fragment } from 'react';
import { Wrapper, Title, Subtitle, Container, Item } from './styles';
import { useTranslation } from 'next-i18next';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
var Section = function Section(_ref) {
  var title = _ref.title,
    features = _ref.features;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(Fragment, null, title ? __jsx(Title, null, title) : null, Object.keys(features).map(function (unitType) {
    var _features$unitType;
    if (!((_features$unitType = features[unitType]) !== null && _features$unitType !== void 0 && _features$unitType.length)) {
      return null;
    }
    var _unitType$split = unitType.split(':'),
      _unitType$split2 = _slicedToArray(_unitType$split, 2),
      unitTypeCode = _unitType$split2[0],
      unitNumber = _unitType$split2[1];
    return __jsx(Wrapper, {
      key: unitTypeCode
    }, __jsx(Subtitle, null, "".concat(t(capitalizeFirstLetter(unitTypeCode)), " ").concat(unitNumber > 0 ? unitNumber : '')), __jsx(Container, null, features[unitType].sort(function (a, b) {
      return b.exists - a.exists;
    }).map(function (_ref2, index) {
      var Component = _ref2.Component,
        translation = _ref2.translation,
        translation_old = _ref2.translation_old,
        exists = _ref2.exists,
        area = _ref2.area;
      return __jsx(Item, {
        className: !exists && 'not_available',
        key: "".concat(translation, "-").concat(index)
      }, __jsx(Component, null), ' ', area ? __jsx("span", null, "".concat(area, " ").concat(t('sqm'))) : __jsx("span", null, t(translation || translation_old)));
    })));
  }));
};
export default Section;